import * as reducers from './reducers/index';
import configureStore from 'infrastructure/js/utils/configureStore'
import { actionTypes as systemActionTypes } from  './actions/System/systemActions.js';

export default configureStore(reducers, systemActionTypes);
